// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kGZeo","expireSoon":"styles_expireSoon__zAzMJ"};